import React, {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import classnames from "classnames";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import useEnterEffect from "../../hooks/useEnterEffect";
import Button from "@mui/material/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";


const initialState = {
    id: null,
    name: 'Registration Fee',
    state: '',
    amount: null,
    is_capped: false,
    is_taxed: true,
    is_tax_capped: false,
}

export const DefaultSettingsCreateRegFee = ({ usState }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()
    const getInitialState = (usState) =>  {
        return ({
            ...initialState,
            state: usState
        })
    }
    const [feeState, setFeeState] = useState(getInitialState(usState))

    const hasRegFee = () => {
        return Boolean(
            feeState &&
            feeState?.state?.length &&
            feeState?.amount !== null
        )
    }

    const setNewRegInSettings = () => {
        if (hasRegFee()) {
            setSettingsStateWithUpdate({
                fees: [...quoteSettings.fees, feeState]
            }, true)
        }
    }

    useEnterEffect(function updateQuoteSettingsStateOnEnter(){
        setNewRegInSettings()
    }, [feeState])

    useEffect(function updateStateWhenUsStateChanges() {
        setFeeState({...feeState, state: usState})
    }, [usState]);


    return (
        <TableRow
            key={'Acq Fee'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
            className={'default-settings-fee ds-create-row'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <span>Registration Fee</span>
                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        disabled={!hasRegFee()}
                        onClick={setNewRegInSettings}
                    >
                        Add <KeyboardReturnIcon/>
                    </Button>
                </div>

            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                    </TableCell>
                    <TableCell
                        className={'DealPageFee'}
                        align="center"
                        size={'small'}
                        width={'20%'}
                    >
                        <Tooltip title={feeState.is_capped ? 'Upfront' : 'Cap'} arrow placement={'top'}>
                            <Switch
                                checked={feeState.is_capped}
                                onChange={() => {
                                    setFeeState({...feeState, is_capped: !feeState.is_capped})
                                }}
                            />
                        </Tooltip>
                    </TableCell>
                </React.Fragment>
            }
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <div className={'fee-input-wrap'}>
                    <span className={'prefix'}>$</span>
                    <CustomCurrencyInput
                        onChange={(value) => setFeeState({...feeState, amount: value})}
                        className={classnames({ loading: false })}
                        value={feeState.amount}
                        allowNull={false}
                        InputProps={{}}
                    />
                </div>
            </TableCell>
        </TableRow>
    )
}